export default "__VITE_ASSET__767c6f44__"